import { useTranslation } from "locales";
import { useState } from "react";
import React, { View } from "react-native";
import { StyleFunction, useThemedStyle } from "../../theme";
import { InputControl } from "../input-control";
import { ModalWrapper } from "./wrapper";
import { TextInput } from "../textinput";
import { Button } from "../button";

export function TextInputModal({
    onClose,
    title,
    label,
    description,
}: {
    onClose: (text?: string) => void;
    title: string;
    label: string;
    description?: string;
}) {
    const [t] = useTranslation();
    const [textValue, setTextValue] = useState<string>("");
    const styles = useThemedStyle(styleFunc);

    return (
        <ModalWrapper onClose={() => onClose(undefined)} title={title}>
            <View style={styles.modalContainer}>
                <InputControl description={description}>
                    <TextInput
                        label={label}
                        onChangeText={text => setTextValue(text)}
                        onSubmitEditing={() => onClose(textValue)}
                        required={true}
                        autoFocus
                    />
                </InputControl>
                <View style={styles.buttonContainer}>
                    <Button
                        type="primary"
                        onPress={() => {
                            onClose(textValue);
                        }}
                        testID="confirm-button"
                    >
                        {t("backoffice.ok", "OK")}
                    </Button>
                </View>
            </View>
        </ModalWrapper>
    );
}

const styleFunc: StyleFunction = theme => ({
    buttonContainer: {
        flexDirection: "row",
        justifyContent: "flex-end",
    },
    modalContainer: {
        padding: theme.spacingScale * 2,
        maxWidth: 500,
    },
});
